/*@flow*/
import type { Element } from 'react';
import React from 'react';

export type DotTypeT = 'circle' | 'square';
export type DotStyleT = 'fill' | 'stroke';

export default ({
  color,
  type,
  dotStyle,
  containerStyle = {},
  edgeWidth = 12,
}: {
  color: string,
  type: DotTypeT,
  dotStyle: DotStyleT,
  containerStyle?: Object,
  edgeWidth?: number,
}): Element<'svg'> => {
  const style =
    dotStyle === 'fill'
      ? { fill: color }
      : { fill: 'white', strokeWidth: 1, stroke: color };

  let shape;
  if (type === 'circle') {
    shape = <circle cx="5" cy="5" r="5" style={style} />;
  } else {
    shape = <rect x="0" y="0" width="10" height="10" style={style} />;
  }

  return (
    <svg
      viewBox={'-1 -1 12 12'}
      style={{
        width: edgeWidth,
        height: edgeWidth,
        top: 2,
        position: 'relative',
        ...containerStyle,
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      {shape}
    </svg>
  );
};
